export const HOME = "/home";
export const NOT_FOUND = "/not-found";
export const MISC = "/misc";
export const PRESTUDY_SPLITTER = "/prestudy-splitter";